<template>
    <div class="formAuthConfig">
      <el-form size="mini" > 
          <el-row>
              <el-col :span="12">
                  <el-form-item label="表单库"  >
                    <el-tooltip  content="从流程任务节点挂载的表单库里选择对应的表单，进行表单字段的详细权限设置" effect="light" placement="top">
                      <i class="el-icon-question"></i>
                    </el-tooltip>
                        <el-select v-if="isShowFormsSel" v-model="formId" placeholder="请选择表单"  @change="handleChangeForm">
                            <el-option
                                v-for="item in forms"
                                :key="item.id+item.taskId"
                                :label="'['+item.taskName+']-'+item.formName"
                                :value="item.id+'-'+item.taskId">
                            </el-option>
                        </el-select>
                      <el-button v-if="formId!==''" size="mini" icon="el-icon-view" title="预览" circle @click="renderModelDetail()"></el-button>
                      <el-button v-if="formId!==''" size="mini" type="primary" icon="el-icon-setting" title="保存权限配置" @click="handleSaveConfig()">保存权限配置</el-button>
                  </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="表单权限">
                  <el-tooltip  content="表单权限：1.选择隐藏则不需要配置表单字段权限 2.选择查看，则先从左侧选择需要查看的哪个任务里对应的哪个表单 3.选择确定好表单后，进入下方字段数据权限详细设置" effect="light" placement="top">
                    <i class="el-icon-question"></i>
                  </el-tooltip>
                    <span v-if="formObj.id">{{'['+formObj.taskName+']-'+formObj.formName}}</span>
                  <el-radio-group v-model="isView" @change="changeFormRadio">
                    <el-radio :disabled="isRead" :label="0">隐藏</el-radio>
                    <el-radio :disabled="isRead" :label="1">查看</el-radio> 
                  </el-radio-group>
                    <!-- <i class="el-icon-question"></i> -->
                </el-form-item>
              </el-col>
          </el-row>

          <!-- 部门字段和子表数据权限关系配置endbegin  --> 
          <div v-if="isView===1&&this.relateForms&&this.relateForms.length>0" :key="loadTimerDept"  > 
              <el-row>
                <el-form-item   label="部门数据权限">
                  <el-tooltip  content="根据从表单库里选择的表单，带出其对应的子表单列表，选择具体的子表单进行表单内部门字段的数据权限设置，表示当前任务只能查看对应部门的子表单数据" effect="light" placement="top">
                    <i class="el-icon-question"></i>
                  </el-tooltip>
                    <el-button type="success" @click="addDeptUserlinkData">新增数据权限关系</el-button>
                </el-form-item>
              </el-row>
              <template v-if="isView===1" >
                  <el-row v-for="(obj,index) in taskData.deptDataAuthConfig" :key="index">
                      <el-col :span="6" >
                        <el-form-item    label="主表关联的子表单">
                          <el-select  v-model="obj.relateFormId" clearable placeholder="请选择关联子表单"  @change="handleChangeRelateForm(obj)">
                            <el-option
                                v-for="item in relateForms"
                                :key="item.formId"
                                :label="item.modelName"
                                :value="item.formId"
                                >
                            </el-option>
                          </el-select>
                        </el-form-item>
                      </el-col>
                      <el-col :span="6" >
                          <el-form-item label="部门字段">
                            <!-- @change="handleDeptFieldChange(obj)" -->
                              <el-select v-model="obj.formFieldId" clearable placeholder="请选择部门字段" class="triggerSource" @change="$forceUpdate()">  
                                  <el-option
                                      v-for="dept in obj.deptFieldList"
                                      :key="dept.id"
                                      :label="dept.name"
                                      :value="dept.id" >
                                  </el-option>
                              </el-select>
                          </el-form-item>
                      </el-col>
                      <el-col :span="6" >
                        <el-tooltip  content="设置部门字段对应的部门值，表示当前任务节点能看到该表单对应部门字段的数据权限" effect="light" placement="top">
                          <Department
                              :ref="'deptTreeChild'+index"
                              :popover="true"
                              :selectedNode="obj.departmentObj"
                              :ifFiltDataSource="true"
                              :listIndex="index"
                              :data="deptTreeData"
                              @nodeClick="handleDeptTreeNode"
                          />
                        </el-tooltip>
                      </el-col>
                      <el-col :span="6" >
                          <div class="opear-delete"><i class="el-icon-delete" @click="delDeptUserlinkData(obj)"></i></div>
                      </el-col>
                  </el-row>
                </template>
            </div>
            <div v-if="isView===1" >
              <!-- 部门字段和子表数据权限关系配置end -->
              <el-form-item label="字段数据权限">
                <el-tooltip  content="字段数据权限：1.先选择字段的查看权限 2.其次选择字段的只读权限 3.再选择对应字段的修改权限" effect="light" placement="top">
                  <i class="el-icon-question"></i>
                </el-tooltip>
                <el-row>
                  <el-col :span="5">
                    <div   style="width: 200px" class="el-transfer-panel" > 
                      <p class="el-transfer-panel__header">
                        <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">查看权限</el-checkbox>
                      </p>
                      <div class="el-transfer-panel__body"  style="margin-left:15px;height:305px;overflow-y:auto">
                          <el-checkbox-group v-model="checkedViewFields" @change="handleCheckedViewFieldsChange">
                              <el-checkbox v-for="(viewField,index) in targetData" :label="viewField.label" :key="index">{{viewField.label}}</el-checkbox>
                          </el-checkbox-group>
                      </div>
                    </div>
                  </el-col>
                  <el-col :span="19" style='float:right'>
                    <!-- :left-default-checked="[2, 3]"
                      :right-default-checked="[1]" -->
                        <!-- @left-check-change="handleClickLeft"
                      @right-check-change="handleClickRight"  
                        :left-default-checked="readOnlyFields"
                      :right-default-checked="modifiedFields" 
                      -->
                    <el-transfer
                        :key="loadTimer"
                        v-if="isView===1"
                        style="text-align: left; display: inline-block"
                        v-model="modifiedFieldArr"
                        filterable
                        :titles="['只读权限', '修改权限']"
                        :button-texts="['', '']"
                        :format="{
                          noChecked: '${total}',
                          hasChecked: '${checked}/${total}'
                        }" 
                        @change="handleChange"
                      
                        :data="targetData">
                        <!-- <span slot-scope="{ option }">{{ option.key }} - {{ option.label }}</span> -->
                      <span slot-scope="{ option }">{{ option.label }}</span>
                        <!-- <el-button class="transfer-footer" slot="left-footer"  @click="handleClickLeft" size="small">保存</el-button>
                        <el-button class="transfer-footer" slot="right-footer"  @click="handleClickRight" size="small">保存</el-button> -->
                    </el-transfer>
                  </el-col>
                </el-row>
            </el-form-item>
          </div>
      </el-form>
      <el-dialog
          class="popViewModelDetail"
          :fullscreen=true
          append-to-body
          :visible.sync="isShowModelDetail"
          >
          <ModelDetail ref="modelDetailChild" :isView="true" :isShowForm="isShowForm" @setIsShowForm="setIsShowForm" :formInfo="formInfo"   />
      </el-dialog>
    </div>
</template>

<script>
    import { cloneDeep, isEmpty } from 'lodash';
    import { getFormConfig, getProcessServiceForms, getProcessModelForms, getModelFormById, getProcessServiceFormsAuth, saveProcessServiceFormAuth, getProcessInstanceFormsAuth, saveProcessInstanceFormAuth, getDepartmentTreeList } from '@/data-model';
    import ModelDetail from '@/pages/business/BusinessApplication/ModelDetail';
    export default {
        components: {
            ModelDetail
        },
        data () {
            // const generateData = _ => {
            //     const data = [];
            //     for (let i = 1; i <= 15; i++) {
            //         data.push({
            //             key: i,
            //             label: `备选项 ${i}`
            //             // disabled: i % 4 === 0
            //         });
            //     }
            //     return data;
            // };
            return {
                checkAll: false,
                checkedViewFields: [],
                // cities: ['上海', '北京2324', '广州大幅度发', '深圳fsdf发顺丰'],
                isIndeterminate: true,
                loadTimer: '',
                isShowFormsSel: false,
                isView: null,
                isRead: false,
                // targetData: generateData(),
                targetData: [],
                forms: [],
                modifiedFieldArr: [],
                formId: '',
                formObj: {},
                isShowForm: false,
                isShowModelDetail: false,
                formInfo: {},
                viewFields: [],
                readOnlyFields: [],
                modifiedFields: [],
                formsAuth: [],
                formsAuthMap: new Map(),
                deptFieldList: [],
                loadTimerDept: new Date().getTime(),
                relateFormId: '',
                relateForms: [],
                currentDeptRelateId: '',
                deptTreeData: []
                // renderFunc (h, option) {
                //     return <span>{ option.key } - { option.label }</span>;
                // }
                // fileList: [],
                //  timeDefaultShow: this.getAfter7Day()
            };
        },
        created () {
            this.forms = [];
            this.formsAuth = [];
            this.isShowFormsSel = false;
            if (!this.taskData.deptDataAuthConfig) {
                this.taskData.deptDataAuthConfig = [];
            }
            this._initPage();
        },
        props: {
            taskData: {
                type: Object
            },
            processInstance: {
                type: Object
            },
            dataOperate: {
                type: Object
            }
        },
        methods: {
            handleCheckAllChange (val) {
                let targetDataNames = [];
                this.targetData.forEach(viewField => {
                    targetDataNames.push(viewField.label);
                    // this.viewFields.push(viewField.id);
                });
                this.checkedViewFields = val ? targetDataNames : [];
                this.isIndeterminate = false;
                // console.log(this.checkedViewFields);
            },
            handleCheckedViewFieldsChange (value) {
                let checkedCount = value.length;
                this.checkAll = checkedCount === this.targetData.length;
                this.isIndeterminate = checkedCount > 0 && checkedCount < this.targetData.length;
            },
            async _initPage () {
                let tempFormsObj = null;
                if (this.processInstance) {
                    tempFormsObj = await getProcessModelForms({// 查询流程实例对应的所有表单
                        processInstanceId: this.processInstance.id,
                        deploymentId: this.taskData.deploymentId,
                        onlyThis: true
                    });
                } else {
                    tempFormsObj = await getProcessServiceForms({// 查询流程模板对应的所有表单
                        processServiceId: this.taskData.processServiceId,
                        deploymentId: this.taskData.deploymentId
                    });
                    await this.resetFormsAuthMap();// 查询当前任务对应的所有表单字段权限
                    // console.log(this.formsAuth);
                }
                let formMap = new Map();
                if (this.dataOperate.forms) {
                    this.dataOperate.forms.forEach(currentTaskForm => {
                        currentTaskForm.taskId = this.taskData.taskId;
                        formMap.set(currentTaskForm.id, currentTaskForm);
                    });
                }
                if (tempFormsObj && Array.isArray(tempFormsObj)) {
                    // structure=tempFormsObj[0].structure;
                    let filterMap = new Map();
                    tempFormsObj.forEach(item => {
                        let objModelFormStructure = item.structure;
                        if (objModelFormStructure) {
                            objModelFormStructure.forEach(form => {
                                if (formMap.has(form.id)) {
                                    if (form.taskId !== formMap.get(form.id).taskId) {
                                        filterMap.set(formMap.get(form.id).taskId + form.id, form);
                                    }
                                }
                            });
                        }
                    });
                    let taskModeType = this.taskData.executor.modeType;
                    let repeatMap = new Map();
                    // this.forms.push(form);
                    tempFormsObj.forEach(item => {
                        let objModelFormStructure = item.structure;
                        if (objModelFormStructure) {
                            objModelFormStructure.forEach(form => {
                                /* ----------------- 20220122 edit by hezhen start ---------------------- */
                                // if (taskModeType === 2) { // 会签节点
                                //     if (!repeatMap.has(form.id )) {
                                //         this.forms.push(form);
                                //         repeatMap.set(form.id, true);
                                //     }
                                // // } else if (!repeatMap.has(form.id)) {
                                // //     this.forms.push(form);
                                // //     repeatMap.set(form.id, true);
                                // // }
                                // } else {
                                //     this.forms.push(form);
                                // }
                                // 放开会签节点约束
                                if (!repeatMap.has(form.id + form.taskId)) {
                                    this.forms.push(form);
                                    repeatMap.set(form.id + form.taskId, true);
                                }
                                /* ----------------- 20220122 edit by hezhen end ---------------------- */
    
                                // if (taskModeType === 2) { // 会签节点
                                //     if (!repeatMap.has(form.id)) {
                                //         this.forms.push(form);
                                //         repeatMap.set(form.id, true);
                                //     }
                                // } else if (filterMap.has(form.taskId + form.id)) { // 过滤掉别的任务节点定义过的在本任务出现的相同的表单
                                //     // this.forms.push(form);
                                //     filterMap.delete(form.taskId + form.id);
                                //     this.forms.push(filterMap.get(form.taskId + form.id));
                                // } else if (!repeatMap.has(form.id)) {
                                //     this.forms.push(form);
                                //     repeatMap.set(form.id, true);
                                // }
                            });
                        }
                    });
                }
                this.isShowFormsSel = true;
                // console.log(this.dataOperate.forms);
            },
            async resetFormsAuthMap () {
                if (this.processInstance) {
                    this.formsAuth = await getProcessInstanceFormsAuth({// 查询流程模板对应的所有表单
                        processInstanceId: this.processInstance.id,
                        taskId: this.taskData.taskId
                    });
                } else {
                    this.formsAuth = await getProcessServiceFormsAuth({// 查询流程模板对应的所有表单
                        processServiceId: this.taskData.processServiceId,
                        deploymentId: this.taskData.deploymentId,
                        taskId: this.taskData.taskId
                    });
                }
                this.formsAuthMap = new Map();
                if (this.formsAuth) {
                    this.formsAuth.forEach(item => {
                        this.formsAuthMap.set(item.sourceTaskId + item.formId, item);
                        if (item.deptDataAuthConfig) {
                            this.taskData.deptDataAuthConfig = JSON.parse(item.deptDataAuthConfig);
                        }
                    });
                }
            },
            handleChange (value, direction, movedKeys) {
                // console.log(this.targetData);
                // console.log(this.readOnlyFields);
                // console.log(this.modifiedFields);
                // console.log(this.modifiedFieldArr);
                // console.log(value);
                // console.log(direction);
                // console.log(movedKeys);
                this.modifiedFields = value;
                let removeKeysMap = new Map();
                this.modifiedFields.forEach(key => {
                    removeKeysMap.set(key, key);
                });
                this.readOnlyFields = [];
                let tempAllData = cloneDeep(this.targetData);
                for (var i = 0, len = tempAllData.length; i < len; i++) {
                    if (tempAllData[i] && !removeKeysMap.has(tempAllData[i].key)) {
                        this.readOnlyFields.push(tempAllData[i].key);
                    }
                }
                // console.log(this.readOnlyFields);
                // console.log(this.modifiedFields);
                // console.log(this.modifiedFieldArr);
            },
            async handleChangeForm (id) {
                let key = this.formObj.id + '-' + this.formObj.taskId;
                if (key !== id) {
                    this.isView = null;
                    this.isRead = false;
                    this.forms.forEach(item => {
                        if (id === (item.id + '-' + item.taskId)) {
                            this.formObj = item;
                        }
                    });
                    await this.initRelateForms();
                    await this.resetTargetData();
                }
            },
            async renderModelDetail () {
                if (this.formObj.modelId) {
                    this.isShowModelDetail = false;
                    this.formInfo = await getModelFormById(this.formObj.modelId);
                    this.isShowModelDetail = true;
                    this.setIsShowForm(false);
                    setTimeout(() => {
                        this.$refs.modelDetailChild.loadFormData(this.formInfo);
                    }, 0);
                    this.formInfo.modelName = this.formInfo.formObj.structure[0].modelName;
                }
            },
            setIsShowForm (status) {
                this.isShowForm = status;
            },
            changeFormRadio (val) {
                if (val === 1) {
                    let targetDataNames = [];
                    this.targetData.forEach(viewField => {
                        targetDataNames.push(viewField.label);
                    });
                    this.checkedViewFields = targetDataNames;
                    this.checkAll = true;
                    this.isIndeterminate = false;
                } else {
                    this.checkedViewFields = [];
                }
            },
            async resetTargetData () {
                this.targetData = [];
                this.viewFields = [];
                this.readOnlyFields = [];
                this.modifiedFields = [];
                this.modifiedFieldArr = [];
                let allFieldMap = new Map();
                this.formObj.fieldsList.forEach(field => { // 数据源
                    if (!isEmpty(field.options.fieldList)) {
                        this.targetData.push({key: field.id, label: field.name + '[子表单]'});
                        this.readOnlyFields.push(field.id);
                        allFieldMap.set(field.id, {key: field.id, label: field.name + '[子表单]'});
                        field.options.fieldList.forEach(subField => { // 数据源
                            this.targetData.push({key: subField.id, label: field.name + '[子表单]-' + subField.name});
                            allFieldMap.set(subField.id, {key: subField.id, label: field.name + '[子表单]-' + subField.name});
                        });
                    } else {
                        this.targetData.push({key: field.id, label: field.name});
                        this.readOnlyFields.push(field.id);
                        allFieldMap.set(field.id, {key: field.id, label: field.name});
                    }
                });
                this.loadTimer = new Date().getTime();
                await this.resetFormsAuthMap();// 刷新最新权限
                this.checkedViewFields = [];
                if (this.formsAuthMap.has(this.formObj.taskId + this.formObj.id)) {
                    // console.log(this.readOnlyFields);
                    this.readOnlyFields = [];
                    this.readOnlyFields = this.formsAuthMap.get(this.formObj.taskId + this.formObj.id).readOnlyFields.split(',');// 左边
                    this.modifiedFields = this.formsAuthMap.get(this.formObj.taskId + this.formObj.id).modifiedFields.split(',');// 右边
                    this.modifiedFieldArr = cloneDeep(this.modifiedFields);// 初始右边的默认值
                    this.isView = 1;
                    if (this.formsAuthMap.get(this.formObj.taskId + this.formObj.id).viewFields) {
                        this.viewFields = this.formsAuthMap.get(this.formObj.taskId + this.formObj.id).viewFields.split(',');// 查看权限，id字段
                        for (let i = 0, len = this.targetData.length; i < len; i++) {
                            this.viewFields.forEach(id => {
                                if (this.targetData[i].key === id) {
                                    this.checkedViewFields.push(this.targetData[i].label);
                                }
                            });
                        }
                    } else {
                        this.changeFormRadio(this.isView);// 初始化
                    }
                    this.modifiedFieldArr = [];
                    this.readOnlyFields = [];
                    let tempModifiedFields = [];
                    let modifiedFieldMap = new Map();
                    this.modifiedFields.forEach(id => {
                        if (allFieldMap.has(id)) {
                            tempModifiedFields.push(id);
                            modifiedFieldMap.set(id, id);
                        }
                    });
                    this.targetData.forEach(oField => {
                        if (!modifiedFieldMap.has(oField.key)) {
                            this.readOnlyFields.push(oField.key);
                        }
                    });
                    this.modifiedFields = tempModifiedFields;
                    this.modifiedFieldArr = cloneDeep(this.modifiedFields);// 初始右边的默认值
                } else {
                    this.isView = 0;
                }
                if (this.taskData.taskId === this.formObj.taskId) { // 当前任务的表单是可以查看的
                    this.isRead = true;
                    this.isView = 1;
                    if (this.checkedViewFields.length === 0) {
                        this.changeFormRadio(this.isView);// 初始化
                    }
                }
                // console.log(this.formsAuthMap.get(this.formObj.taskId + this.formObj.id));
                // console.log(this.readOnlyFields);
                // console.log(this.modifiedFields);
            },
            handleSaveConfig () {
                // 单选模式，只能设置一个默认值
                this.viewFields = [];
                for (let i = 0, len = this.targetData.length; i < len; i++) {
                    this.checkedViewFields.forEach(label => {
                        if (this.targetData[i].label === label) {
                            this.viewFields.push(this.targetData[i].key);
                        }
                    });
                }
                // console.log(this.viewFields);
                if (this.viewFields.length === 0) {
                    // console.log(11111111111111111111);
                    // console.log(this.isView);
                    if (this.isView === 1) { // 查看模式
                        this.$message({
                            message: '表单权限选择查看时字段权限列表中选择字段不能为空',
                            type: 'warning',
                            duration: 3000
                        });
                        return;
                    }
                }
    
                let param = {
                    processServiceId: this.taskData.processServiceId,
                    deploymentId: this.taskData.deploymentId,
                    taskId: this.taskData.taskId,
                    sourceTaskId: this.formObj.taskId,
                    formId: this.formObj.id,
                    viewFields: this.viewFields.join(','),
                    readOnlyFields: this.readOnlyFields.join(','),
                    modifiedFields: this.modifiedFields.join(','),
                    deptDataAuthConfig: this.taskData.deptDataAuthConfig ? JSON.stringify(this.taskData.deptDataAuthConfig) : null
                };
                if (this.isView === 0) {
                    param.isDelete = true;
                }
                if (this.formsAuthMap.has(this.formObj.taskId + this.formObj.id)) {
                    param.id = this.formsAuthMap.get(this.formObj.taskId + this.formObj.id).id;
                }
                // console.log(param);
                this.$confirm(`您确定给当前任务设置[ ${this.formObj.formName} ]的字段权限吗？`, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(async (res) => {
                    if (this.processInstance) {
                        param.processInstanceId = this.processInstance.id;
                        await saveProcessInstanceFormAuth(param);
                    } else {
                        await saveProcessServiceFormAuth(param);
                    }
                }).catch(() => {});
            },
            addDeptUserlinkData () {
                let item = {
                    id: this.generateUUID(),
                    relateFormId: '',
                    formId: '',
                    formFieldId: '',
                    formFieldValue: ''
                };
                this.taskData.deptDataAuthConfig.push(item); // list尾部新增
                this.loadTimerDept = new Date().getTime();
            },
            handleDeptFieldChange (obj) {
                this.currentDeptRelateId = obj.id;
                for (let j = 0; j < obj.deptFieldList.length; j++) {
                    if (obj.deptFieldList[j].id === obj.formFieldId) {
                        obj.formId = this.deptFieldList[j].formId;
                        break;
                    }
                }
            },
            handleDeptTreeNode (data, node, tree, listIndex) {
                // console.log(data);
                // console.log(this.currentDeptRelateId);
                // 部门
                for (let i = 0; i < this.taskData.deptDataAuthConfig.length; i++) {
                    let cur = this.taskData.deptDataAuthConfig[i];
                    if (i === listIndex) {
                        cur.formFieldValue = data.id;
                        cur.departmentObj = {};
                        cur.departmentObj.id = data.id;
                        cur.departmentObj.label = data.label;
                    }
                }
                // console.log(this.templateInfo.deptUserlinkData);
            },
            delDeptUserlinkData (e) {
                for (let i = 0; i < this.taskData.deptDataAuthConfig.length; i++) {
                    let cur = this.taskData.deptDataAuthConfig[i];
                    if (cur.id === e.id) {
                        this.taskData.deptDataAuthConfig.splice(i, 1);
                    }
                }
                this.loadTimerDept = new Date().getTime();
            },
            generateUUID () {
                var d = new Date().getTime();
                if (window.performance && typeof window.performance.now === 'function') {
                    d += window.performance.now(); // use high-precision timer if available
                }
                var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
                    var r = (d + Math.random() * 16) % 16 | 0;
                    d = Math.floor(d / 16);
                    return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
                });
                return uuid.replace(RegExp('-', 'g'), '');
            },
            async initFormDeptFieldList (relateFormObj, obj) {
                let deptFieldList = [];
                let formData = await getFormConfig(relateFormObj.formId);
                if (formData) {
                    let fieldsList = formData.fieldsList;
                    for (let j = 0; j < fieldsList.length; j++) {
                        let itemCur = fieldsList[j];
                        if (itemCur.type === 'department') {
                            itemCur.formId = relateFormObj.relateFormId;
                            deptFieldList.push(itemCur);
                        }
                    }
                    obj.deptFieldList = deptFieldList;
                }
                this.loadTimerDept = new Date().getTime();
            },
            async handleChangeRelateForm (obj) {
                // let key = this.formObj.id + '-' + this.formObj.taskId;
                // if (key !== id) {
                //     this.isView = null;
                //     this.isRead = false;
                let relateFormObj = {};
                obj.formFieldId = '';
                this.relateForms.forEach(item => {
                    if (obj.relateFormId === item.formId) {
                        relateFormObj = item;
                    }
                });
                await this.initFormDeptFieldList(relateFormObj, obj);
                // }
            },
            async initRelateForms () {
                this.relateForms = [];
                this.relateForms = this.formObj.relateModelList;
                if (this.relateForms && this.relateForms.length > 0) {
                    await this.initDeptData();
                }
            },
            async initDeptData () {
                if (!this.deptTreeData || this.deptTreeData.length < 1) {
                    this.deptTreeData = await getDepartmentTreeList();
                }
            }
            // handleClickLeft (obj1, obj2) {
            //     console.log(obj1);
            //     console.log(obj2);
            // },
            // handleClickRight (obj1, obj2) {
            //     console.log(obj1);
            //     console.log(obj2);
            // }
        }
    };
</script>

<style lang="less">
  .formAuthConfig{
    .transfer-footer {
      margin-left: 20px;
      padding: 6px 5px;
    }
    .el-transfer-panel {
      border: 1px solid #ebeef5;
      /* border-radius: 4px; */
      overflow: hidden;
      background: #fff;
      display: inline-block;
      vertical-align: middle;
      width: 350px;
      max-height: 100%;
      box-sizing: border-box;
      position: relative;
    }
    .opear-delete{
        cursor: pointer;
        text-align: center;
        padding-right: 20px;
        height: 0px;
        z-index: 999;
    }
  }
 .popViewModelDetail{
    .el-dialog__body {
        padding: 5px 30px 0px 0px;
        color: #606266;
        font-size: 14px;
        word-break: break-all;
    }
  }
  
</style>


// WEBPACK FOOTER //
// src/pages/process/ProcessEditor/components/FormAuthConfig.vue